import { Observable, Subject } from "rxjs";

export class OverviewSettingsMenuService {
  private _onMenuOpen$: Subject<void> = new Subject<void>();

  public onMenuOpen$: Observable<void> = this._onMenuOpen$.asObservable();


  public openMenu (): void {
    this._onMenuOpen$.next();
  }
}
